import { render, staticRenderFns } from "./EdicionDosisMedicamento.vue?vue&type=template&id=2a607183&"
import script from "./EdicionDosisMedicamento.vue?vue&type=script&lang=js&"
export * from "./EdicionDosisMedicamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports